import BaseService from "./base.service";

export default class ComunityFeaturedService extends BaseService {
	constructor() {
		super(`comunidade/topicos/destaque`);
	}
}
